import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'facturaNumero'
})
export class FacturaNumeroPipe implements PipeTransform {

  transform(value: number): string {
    if (value !== undefined && value !== null) {
      return value.toString().padStart(8, '0');
    } else {
      return "";
    }
  }

}
